export enum SortDishwasherBy {
    HighToLow = 1,
    LowToHigh = 2,
    NameAZ = 3,
    NameZA = 4,
    TrendingNow = 5,
}
